// SQL dump (.sql) oxuyucu: mysqldump / phpMyAdmin / SQLite .dump / SQL Server skriptləri.
// FiscalSTOK-dan köçürülüb. Backend nüsxəsi: pos_restaurant/routes/_sqlDump.js (eyni məntiq).
// CREATE TABLE-dən sütun adlarını, INSERT INTO ... VALUES-dan sətirləri çıxarır.
// Nəticə: [{ table, columns: [..], rows: [{ col: value }] }] (İdxal v2 üçün, brauzerdə işləyir).

// Statement-lərə böl (dırnaq, şərh və mötərizələrə hörmətlə)
function splitStatements(text) {
  const out = [];
  let buf = '';
  let i = 0;
  const n = text.length;
  while (i < n) {
    const c = text[i];
    const c2 = text[i + 1];
    // Sətir şərhləri: "-- " və "#"
    if ((c === '-' && c2 === '-' && /\s/.test(text[i + 2] || ' ')) || (c === '#' && buf.trim() === '')) {
      while (i < n && text[i] !== '\n') i++;
      continue;
    }
    // Blok şərhi /* ... */ (MySQL /*!40101 ... */ daxil)
    if (c === '/' && c2 === '*') {
      const end = text.indexOf('*/', i + 2);
      i = end < 0 ? n : end + 2;
      buf += ' ';
      continue;
    }
    // Dırnaqlar: ' " ` [
    if (c === "'" || c === '"' || c === '`' || c === '[') {
      const close = c === '[' ? ']' : c;
      let j = i + 1;
      while (j < n) {
        const d = text[j];
        if (d === '\\' && c !== '`' && c !== '[') { j += 2; continue; }
        if (d === close) {
          if (text[j + 1] === close && c !== '[') { j += 2; continue; } // '' / "" escape
          break;
        }
        j++;
      }
      buf += text.slice(i, j + 1);
      i = j + 1;
      continue;
    }
    if (c === ';') {
      if (buf.trim()) out.push(buf.trim());
      buf = '';
      i++;
      continue;
    }
    // SQL Server "GO" ayırıcısı (ayrıca sətirdə)
    if ((c === 'G' || c === 'g') && (c2 === 'O' || c2 === 'o') && /(^|\n)\s*$/.test(buf.slice(-50)) && /^\s*(\r?\n|$)/.test(text.slice(i + 2, i + 4))) {
      if (buf.trim()) out.push(buf.trim());
      buf = '';
      i += 2;
      continue;
    }
    buf += c;
    i++;
  }
  if (buf.trim()) out.push(buf.trim());
  return out;
}

const IDENT = '(?:`[^`]+`|"[^"]+"|\\[[^\\]]+\\]|[\\w$]+)';
const QNAME = `(${IDENT}(?:\\s*\\.\\s*${IDENT})*)`;

function unquote(s) {
  s = String(s || '').trim();
  if ((s[0] === '`' && s.endsWith('`')) || (s[0] === '"' && s.endsWith('"')) || (s[0] === '[' && s.endsWith(']'))) return s.slice(1, -1);
  return s;
}
// `db`.`cedvel` → cedvel
function tableName(q) {
  const parts = q.match(new RegExp(IDENT, 'g')) || [q];
  return unquote(parts[parts.length - 1]);
}

// Üst səviyyədə vergüllə böl (mötərizə və dırnaq içində yox)
function splitTop(s) {
  const out = [];
  let depth = 0, cur = '', q = null;
  for (let i = 0; i < s.length; i++) {
    const c = s[i];
    if (q) {
      cur += c;
      if (c === '\\' && q !== '`') { cur += s[++i] || ''; continue; }
      if (c === q) { if (s[i + 1] === q) { cur += s[++i]; continue; } q = null; }
      continue;
    }
    if (c === "'" || c === '"' || c === '`') { q = c; cur += c; continue; }
    if (c === '(') depth++;
    if (c === ')') depth--;
    if (c === ',' && depth === 0) { out.push(cur); cur = ''; continue; }
    cur += c;
  }
  if (cur.trim()) out.push(cur);
  return out.map(x => x.trim()).filter(Boolean);
}

const NON_COL = /^(PRIMARY|KEY|UNIQUE|CONSTRAINT|INDEX|FOREIGN|CHECK|FULLTEXT|SPATIAL|PERIOD|EXCLUDE)\b/i;

function parseCreate(st) {
  const m = st.match(new RegExp(`^CREATE\\s+(?:TEMPORARY\\s+)?TABLE\\s+(?:IF\\s+NOT\\s+EXISTS\\s+)?${QNAME}\\s*\\(`, 'i'));
  if (!m) return null;
  const start = st.indexOf('(', m[0].length - 1);
  const end = st.lastIndexOf(')');
  if (start < 0 || end <= start) return null;
  const defs = splitTop(st.slice(start + 1, end));
  const columns = [];
  for (const d of defs) {
    if (NON_COL.test(d)) continue;
    const cm = d.match(new RegExp(`^${IDENT}`));
    if (cm) columns.push(unquote(cm[0]));
  }
  return { table: tableName(m[1]), columns };
}

// VALUES (...),(...) → massivlər
function parseTuples(s) {
  const rows = [];
  let i = 0;
  const n = s.length;
  const ws = () => { while (i < n && /\s/.test(s[i])) i++; };
  while (i < n) {
    ws();
    if (s[i] === ',') { i++; continue; }
    if (s[i] !== '(') break;
    i++;
    const vals = [];
    for (;;) {
      ws();
      if (s[i] === ')') { i++; break; }
      if (i >= n) break;
      let v;
      // N'..' (SQL Server), _utf8'..', _binary'..'
      const pre = s.slice(i).match(/^(?:N|_\w+\s*)(?=')/i);
      if (pre) i += pre[0].length;
      if (s[i] === "'") {
        let out = '';
        i++;
        while (i < n) {
          const c = s[i];
          if (c === '\\') {
            const e = s[i + 1];
            out += e === 'n' ? '\n' : e === 't' ? '\t' : e === 'r' ? '\r' : e === '0' ? '\0' : e === 'Z' ? '\x1a' : e;
            i += 2; continue;
          }
          if (c === "'") {
            if (s[i + 1] === "'") { out += "'"; i += 2; continue; }
            i++; break;
          }
          out += c; i++;
        }
        v = out;
      } else {
        // NULL, rəqəm, funksiya və s.: üst səviyyədə , və ya ) qədər
        let depth = 0, raw = '';
        while (i < n) {
          const c = s[i];
          if (c === '(') depth++;
          else if (c === ')') { if (depth === 0) break; depth--; }
          else if (c === ',' && depth === 0) break;
          raw += c; i++;
        }
        raw = raw.trim();
        if (/^null$/i.test(raw)) v = null;
        else if (/^[-+]?(\d+\.?\d*|\.\d+)(e[-+]?\d+)?$/i.test(raw)) v = Number(raw);
        else if (/^(true|false)$/i.test(raw)) v = /^true$/i.test(raw) ? 1 : 0;
        else v = raw;
      }
      vals.push(v);
      ws();
      if (s[i] === ',') { i++; continue; }
      if (s[i] === ')') { i++; break; }
    }
    rows.push(vals);
  }
  return rows;
}

function parseInsert(st) {
  const m = st.match(new RegExp(`^(?:INSERT|REPLACE)\\s+(?:LOW_PRIORITY\\s+|DELAYED\\s+|HIGH_PRIORITY\\s+|IGNORE\\s+|OR\\s+\\w+\\s+)*(?:INTO\\s+)?${QNAME}\\s*(\\(([^)]*)\\))?\\s*VALUES\\s*`, 'i'));
  if (!m) return null;
  const cols = m[3] ? splitTop(m[3]).map(unquote) : null;
  return { table: tableName(m[1]), columns: cols, tuples: parseTuples(st.slice(m[0].length)) };
}

export function parseSqlDump(text) {
  const map = new Map();
  const get = name => {
    const k = name.toLowerCase();
    if (!map.has(k)) map.set(k, { table: name, columns: [], raw: [] });
    return map.get(k);
  };
  for (const st of splitStatements(String(text || '').replace(/^﻿/, ''))) {
    if (/^CREATE\s/i.test(st)) {
      const c = parseCreate(st);
      if (c) { const t = get(c.table); if (!t.columns.length) t.columns = c.columns; }
      continue;
    }
    if (/^(INSERT|REPLACE)\s/i.test(st)) {
      const ins = parseInsert(st);
      if (ins) get(ins.table).raw.push(ins);
    }
  }
  const out = [];
  for (const t of map.values()) {
    if (/^sqlite_/i.test(t.table)) continue;   // SQLite daxili cədvəlləri
    let columns = t.columns.slice();
    const rows = [];
    for (const ins of t.raw) {
      const cols = ins.columns || columns;
      for (const c of cols) if (!columns.includes(c)) columns.push(c);
      for (const vals of ins.tuples) {
        const o = {};
        vals.forEach((v, idx) => {
          let c = cols[idx];
          if (!c) { c = `c${idx + 1}`; if (!columns.includes(c)) columns.push(c); }
          o[c] = v;
        });
        rows.push(o);
      }
    }
    out.push({ table: t.table, columns, rows });
  }
  return out;
}
